var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"text-center"},[_vm._v("系统设置")])}
var staticRenderFns = []

export { render, staticRenderFns }